module.exports = __webpack_public_path__ + "static/media/KMH_4891.93d03583.jpg";